import { render } from "./InsuranceClaimsLogin.vue?vue&type=template&id=90aba29c&scoped=true"
import script from "./InsuranceClaimsLogin.vue?vue&type=script&lang=js"
export * from "./InsuranceClaimsLogin.vue?vue&type=script&lang=js"

import "./InsuranceClaimsLogin.vue?vue&type=style&index=0&id=90aba29c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90aba29c"]])

export default __exports__